import L from "leaflet";
import marker from "./marker/marker.png";
import markerLarge from "./marker/markerLarge.png";

const MapMarker = {
    createIcon: (isBigMarker) => {
        return L.icon({
            iconUrl: isBigMarker ? markerLarge : marker,
            iconSize: isBigMarker ? [56, 76] : [28, 38],
            iconAnchor: isBigMarker ? [25, 50] : [12, 41],
            popupAnchor: isBigMarker ? [0, -50] : [0, -41],
        });
    },
};

export default MapMarker;



// WEBPACK FOOTER //
// ./src/components/MapMarker/index.js